import { render, staticRenderFns } from "./failNoticeTable.vue?vue&type=template&id=3c93d8cf&scoped=true&"
import script from "./failNoticeTable.vue?vue&type=script&lang=js&"
export * from "./failNoticeTable.vue?vue&type=script&lang=js&"
import style0 from "./failNoticeTable.vue?vue&type=style&index=0&id=3c93d8cf&lange=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c93d8cf",
  null
  
)

export default component.exports